<template>
  <el-dialog
    title="题目反馈"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
  >
    <el-form :model="feedbackForm" :rules="rules" ref="feedbackForm" label-width="100px">
      <el-form-item label="反馈类型" prop="feedbackType">
        <el-select v-model="feedbackForm.feedbackType" placeholder="请选择反馈类型" style="width: 100%">
          <el-option label="题干问题" :value="1"></el-option>
          <el-option label="选项问题" :value="2"></el-option>
          <el-option label="图片问题" :value="3"></el-option>
          <el-option label="解析问题" :value="4"></el-option>
          <el-option label="答案问题" :value="5"></el-option>
          <el-option label="其他问题" :value="6"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="问题描述" prop="content">
        <el-input
          type="textarea"
          v-model="feedbackForm.content"
          :rows="5"
          placeholder="请详细描述您发现的问题，以便我们更好地改进题目质量"
        ></el-input>
      </el-form-item>

      <el-form-item label="截图上传">
        <el-upload
          action=""
          list-type="picture-card"
          :auto-upload="false"
          :on-change="handleImageChange"
          :on-remove="handleImageRemove"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <div slot="tip" class="el-upload__tip">支持上传问题截图，帮助我们更快定位问题</div>
      </el-form-item>

      <el-form-item label="优先级" prop="priority">
        <el-radio-group v-model="feedbackForm.priority">
          <el-radio :label="1">低</el-radio>
          <el-radio :label="2">中</el-radio>
          <el-radio :label="3">高</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm" :loading="submitting">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { submitFeedback } from '@/api/amcQuestionFeedback'

export default {
  name: 'QuestionFeedbackDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    questionId: {
      type: Number,
      required: true
    },
    courseId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      feedbackForm: {
        amcQuestionId: null,
        courseId: null,
        feedbackType: null,
        content: '',
        images: null,
        priority: 2
      },
      fileList: [],
      rules: {
        feedbackType: [
          { required: true, message: '请选择反馈类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请描述问题', trigger: 'blur' },
          { min: 10, message: '问题描述至少10个字符', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.feedbackForm.amcQuestionId = this.questionId
          this.feedbackForm.courseId = this.courseId
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.resetForm()
    },

    handleImageChange(file, fileList) {
      this.fileList = fileList
      // 这里可以实现图片上传到服务器的逻辑
      // 简化处理：将图片转为base64或上传后获取URL
      console.log('图片变化', file)
    },

    handleImageRemove(file, fileList) {
      this.fileList = fileList
    },

    submitForm() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        this.submitting = true
        try {
          // 处理图片URL（如果有）
          if (this.fileList.length > 0) {
            const imageUrls = this.fileList.map(file => file.url || file.name)
            this.feedbackForm.images = JSON.stringify(imageUrls)
          }

          await submitFeedback(this.feedbackForm)
          this.$message.success('反馈提交成功，感谢您的反馈！')
          this.handleClose()
          this.$emit('success')
        } catch (error) {
          console.error('提交反馈失败', error)
          this.$message.error('提交失败：' + (error.message || '未知错误'))
        } finally {
          this.submitting = false
        }
      })
    },

    resetForm() {
      this.$refs.feedbackForm && this.$refs.feedbackForm.resetFields()
      this.fileList = []
      this.feedbackForm = {
        amcQuestionId: null,
        courseId: null,
        feedbackType: null,
        content: '',
        images: null,
        priority: 2
      }
    }
  }
}
</script>

<style scoped>
.el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}
</style>
